import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = { class: "text-semi-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["LotAssignmentModal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close,
    onConfirm: $setup.confirm
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "text-semi-bold" }, "Confirm Action", -1)
    ]))]),
    description: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode("Are you sure you want to assign ", -1)),
      _createElementVNode("span", _hoisted_1, "Lot " + _toDisplayString($props.lot?.lot), 1),
      _cache[2] || (_cache[2] = _createTextVNode(" to ", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.lot?.name), 1),
      _cache[3] || (_cache[3] = _createTextVNode("? All other active requests will automatically be declined for this lot.", -1))
    ]),
    _: 1
  }, 8, ["is-open"]))
}